/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './styles/Overlay.scss';

type Props = {
  children?: React.Node,
  className?: string,
};

/**
 * ```example
 * <div style={{ width: 200, height: 200, background: '#2f75c1', position: 'relative' }}>
 *   <Overlay />
 * </div>
 * ```
 */

function Overlay(props: Props) {
  return <div className={cx('Overlay', props.className)}>{props.children}</div>;
}

export default Overlay;
